function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   overflow: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { TopNavMenu } from './TopNavMenu';
var TopNavCollapsibleMenu = styled(TopNavMenu)(_templateObject());
TopNavCollapsibleMenu.defaultProps = {
  'data-rcl-collapsible-menu': true
};
export { TopNavCollapsibleMenu };